export const ACCOUNTING_CUSTOMERS_FILTERS_SET = {
    customSets: [],
    staticSets: [
        {
            id: 'act',
            name: 'active',
            default: true,
            fixed: true,
            filters: [
                {
                    name: 'Storage',
                    value: false,
                },
            ],
        },
        {
            id: 'storage',
            name: 'in storage',
            default: true,
            fixed: true,
            filters: [
                {
                    name: 'Storage',
                    value: true,
                },
            ],
        },
        {
            id: 'all',
            name: 'all',
            default: true,
            fixed: true,
            filters: [],
        },
    ],
};
